module.exports = __webpack_public_path__ + "static/WEDDING E&M-6-8c907ff2a1b983577ed51496ffc5d402.jpg";